export default {
    methods: {
        formatCategoryTitle(name) {
            const filtered = this.$options.filters.camelCase(name);
            return filtered.replace(/®/g, '<sup>®</sup>');
        },
        getCategoryName(category) {
            //  get category name based on language
            const locale = this.$i18n.locale;
            if (locale === 'en' || !category.Translations) {
                return category.Name
            }

            const translatedName = category.Translations.find(t => t.Culture === locale);
            return translatedName && translatedName.Name ? translatedName.Name : category.Name;
        },
        getCategoryDescription(category) {
            //  get category description based on language
            const locale = this.$i18n.locale;
            if (locale === 'en' || !category.Translations) {
                return category.Description
            }

            const translatedName = category.Translations.find(t => t.Culture === locale);
            return translatedName && translatedName.Description ? translatedName.Description : category.Description;
        }

    }
}